import { Box } from '@material-ui/core'
import { isEmpty } from 'lodash'
import styled from 'styled-components'

import { Card } from '../../../components/Base/Base'
import { CreateIssueButton } from '../../../components/Issues/CreateIssueButton'
import { IssueListGrid } from '../../../components/Issues/IssueListGrid'
import { IssueRowItem } from '../../../components/Issues/IssueRowItem'
import { InlineSpinner } from '../../../components/Spinner'
import { Text } from '../../../components/Text/Text'
import { useIssues } from '../../../hooks/query/useIssues'
import { lightGray1, lightGray2 } from '../../../theme/colors'

interface ProfileIssuesProps {
  userId: string
}

export function ProfileIssues({ userId }: ProfileIssuesProps) {
  const { issues, isLoading, refetch } = useIssues(userId)

  if (isLoading) {
    return <InlineSpinner mt={5} mb={5} />
  }

  if (isEmpty(issues)) {
    return (
      <StyledCard hasSubtleShadow smallerPadding align="left">
        <Box mt={5} mb={5}>
          <Text variant="header2" fontColor={lightGray2} align="center" mb={2}>
            No Issues Reported
          </Text>
          <Box mb={2} display="flex" justifyContent="center">
            <CreateIssueButton userId={userId} refetch={refetch} />
          </Box>
        </Box>
      </StyledCard>
    )
  }

  return (
    <>
      <Box mt={-2} mb={2}>
        <CreateIssueButton userId={userId} refetch={refetch} />
      </Box>
      <StyledCard hasSubtleShadow smallerPadding align="left">
        <IssueListGrid>
          <Text variant="label2" fontColor={lightGray1}>
            Type
          </Text>
          <Text variant="label2" fontColor={lightGray1}>
            Status
          </Text>
          <Text variant="label2" fontColor={lightGray1}>
            Date Created
          </Text>
        </IssueListGrid>
        <Box mt={3} />
        {issues.map((issue: any) => (
          <IssueRowItem key={issue.id} issue={issue} />
        ))}
      </StyledCard>
    </>
  )
}

const StyledCard = styled(Card)`
  padding-bottom: 1;
`
